import React, { useState, useEffect } from 'react';
import { View } from 'react-native';
import { translate } from '../../../services/translate';
import FormInput from '../../FormInput';
import { centralAPI } from '../../../services/central-api';
import { dispatchService } from '../../../services/central-api/dispatch';
import MyPhoneInput from '../../MyPhoneInput';
import FilterDropdown from '../../Filter/components/FilterDropdown';
import OccurrenceTypeDropdown from '../OccurrenceTypeDropdown';
import CityPropertyDropdown from '../CityPropertyDropdown';
import CustomButton from '../../CustomButton';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import LocationSelector from '../../LocationSelector';
import Toast from 'react-native-toast-message';
import moment from 'moment';

let timer: NodeJS.Timeout;

export default function OccurrenceFormDefault({
    authenticatedUser,
    occurrenceId,
    setRequester,
    setPhone,
    setOccurrenceTypeId,
    setPin,
    requester,
    phone,
    currentAddress,
    setCurrentAddress,
    occurrenceTypeId,
    setCityPropertyId,
    cityPropertyId,
    actingBodyId,
    setActingBodyId,
    createdAt
}: {
    authenticatedUser?: AuthenticatedUser | null;
    occurrenceId?: number;
    setRequester: (name: string) => void;
    setPhone: (phone: string) => void;
    setOccurrenceTypeId: React.Dispatch<React.SetStateAction<number>>;
    setPin: (pos: LatLng) => void;
    requester: string;
    phone: string;
    currentAddress?: string;
    setCurrentAddress: (value: string) => void;
    occurrenceTypeId: number;
    actingBodyId: number;
    setActingBodyId: React.Dispatch<React.SetStateAction<number>>;
    setCityPropertyId: React.Dispatch<React.SetStateAction<number>>;
    cityPropertyId: number;
    createdAt?: string | Date;
}) {
    const [address, setAddress] = useState<string>(currentAddress || '');
    const [selectableActingBodies, setSelectableActingBodies] = useState<{ label: string; value: number; }[]>([]);

    function getPlacesByAddress(delay: number) {
        clearTimeout(timer);

        timer = setTimeout(async () => {
            try {
                if (address) {
                    setCurrentAddress(address);
                    const response = await centralAPI.getPlaceByAddress(address);
                    setPin(response?.candidates[0]?.geometry?.location);
                }
            } catch (err) {
                console.error(err);
            }
        }, delay);

    }

    async function getActingBodies() {
        try {
            const actingBodies = await dispatchService.getActingBodies();
            setSelectableActingBodies(actingBodies.map((actingBody) => {
                return {
                    value: actingBody.id,
                    label: actingBody.name
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (!authenticatedUser) {
            return;
        }

        if (authenticatedUser.isAdmin || authenticatedUser.permissions.dispatch_manage_all_acting_bodies_occurrences) {
            getActingBodies();
        }
    }, [authenticatedUser]);

    useEffect(() => {
        getPlacesByAddress(700);
    }, [address]);

    useEffect(() => {
        if (currentAddress && currentAddress != address) {
            setAddress(currentAddress);
        }
    }, [currentAddress]);

    return (
        <View style={{ rowGap: 20 }}>
            {(authenticatedUser?.isAdmin || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_occurrences) && <FilterDropdown
                label={translate('actingBody')}
                required={true}
                items={selectableActingBodies}
                multiple={false}
                setValue={setActingBodyId}
                value={actingBodyId}
                zIndex={6}
                disabled={!!occurrenceId}
                labelFontSize={14}
            />}

            {occurrenceId && createdAt && (
                <FormInput
                    label={translate('createdAt')}
                    placeholder={translate('createdAt')}
                    value={moment(createdAt).format('DD/MM/YYYY HH:mm:ss')}
                    disabled={true}
                    onChangeText={() => { }}
                />
            )}

            <FormInput
                label={translate('requester')}
                placeholder={translate('requester')}
                value={requester}
                onChangeText={setRequester}
            />

            <MyPhoneInput
                label={translate('phone')}
                placeholder={translate('phone')}
                value={phone}
                onChangeText={setPhone}
                invalid={(value: string) => {
                    return value != '' && value.length < 10;
                }}
            />
            <OccurrenceTypeDropdown
                value={occurrenceTypeId}
                setValue={setOccurrenceTypeId}
                zIndex={5}
                labelFontSize={14}
                label={translate('type')}
                actingBodyId={actingBodyId}
                required={true}
            />

            <CityPropertyDropdown
                value={cityPropertyId}
                setValue={setCityPropertyId}
                zIndex={4}
                labelFontSize={14}
                actingBodyId={actingBodyId}
                setPin={setPin}
                setCurrentAddress={setCurrentAddress}
                includeEmptyValue={true}
            />

            <View style={{ rowGap: 5, zIndex: 3, flex: 1 }}>
                <LocationSelector
                    label={translate('location')}
                    address={address || ''}
                    onAddressChange={setAddress}
                    onInputChange={setAddress}
                    disabled={cityPropertyId ? true : false}
                    labelFontSize={14}
                    viewStyle={{ zIndex: 10 }}
                    required={true}
                />
                <CustomButton
                    icon={faCopy}
                    onPress={async () => {
                        if (!currentAddress) {
                            return;
                        }
                        await navigator.clipboard.writeText(currentAddress);
                        Toast.show({
                            type: 'sentinelxSuccess',
                            text1: translate('copiedToClipboard'),
                        });
                    }}
                    disabled={!currentAddress}
                    type='secondary'
                    text={translate('copyLocation')}
                />
            </View>
        </View>
    );
}
